import {$dom} from "../../../helpers/dom";
import variables from "../../../variables";
import {$data} from "../../../helpers/data";
import gsap from "gsap";

export const animationTargetAttr = 'data-animation-target';
const animationSectionAttr = 'data-animation-section';

export const getAnimation= (params = {}) => {
    const defaults = {
        name: '',
        returnSelector: true,
        domMethod: 'get'
    }
    const options = $data.merge(defaults, params);

    const {name: targetName, returnSelector, domMethod: method} = options;

    const selector = `[${animationTargetAttr}='${targetName}']`;

    return {
        element: returnSelector ? selector : ($dom.exist(selector) ? $dom[method](selector) : null),
        section: $dom.exist(selector) ? $dom.getParent($dom.get(selector), `[${animationSectionAttr}]`) : null
    }
}

export const initSectionsAnimations = sections => {
    sections.forEach(({name, axis, oddAxis, direction = 1}) => {
        const {element, section} = getAnimation({name});

        element && gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: '20% 80%',
                markers: false
            }
        })
            .fromTo(element, {
                [axis]: oddAxis
                    ? i => animationShift * (i%2 === 0 ? -1 : 1)
                    : animationShift * direction,
                autoAlpha: 0
            }, {
                [axis]: 0,
                autoAlpha: 1,
                stagger: .15,
                onComplete: () => {
                    gsap.set(element, {clearProps: 'x,y'})
                }
            });
    })
}

export const defaultDuration = variables.gsapDefaultDuration * 1.6;
export const animationShift = 100;
